import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError] = useState(null);
  const { pollingInterval } = formData;
  const handleSubmit = () => {
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue,
        min: "1",
        max: "60",
        onChange,
        required: true,
        help: t("gmail.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
